import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const BREADCRUMB_CLASS_NAME = 'Breadcrumb';
export const BREADCRUMB_CLASS_SLOTS = ['root', 'icon', 'label'] as const;

export type BreadcrumbClassSlot = (typeof BREADCRUMB_CLASS_SLOTS)[number];

export interface BreadcrumbClasses {
	root: string;
	icon: string;
	label: string;
}

export type BreadcrumbClassKey = keyof BreadcrumbClasses;

export const getBreadcrumbUtilityClass = (slot: string) =>
	generateUtilityClass(BREADCRUMB_CLASS_NAME, slot);

export const breadcrumbClasses: BreadcrumbClasses = generateUtilityClasses(
	BREADCRUMB_CLASS_NAME,
	['root', 'icon', 'label'],
);

export default breadcrumbClasses;
